import type { ExpertProfile } from '@/util/mapDirectoryProfiles';

type ResolveSelectedExpertsParams = {
  expert?: ExpertProfile | null;
  expertIds?: (string | number)[] | null;
  allExperts: ExpertProfile[];
};

export function resolveSelectedExperts({
  expert,
  expertIds,
  allExperts,
}: ResolveSelectedExpertsParams): ExpertProfile[] {
  const additionalExperts =
    expertIds?.map((expertId) =>
      allExperts.find((candidate) => candidate.id === String(expertId))
    ) ?? [];

  return [expert, ...additionalExperts].filter((selectedExpert): selectedExpert is ExpertProfile =>
    Boolean(selectedExpert)
  );
}
